<div class="pre-footer">
  <p class="pre-footer__content">
    Une initiative du Gouvernement pour accompagner, former et faciliter l&apos;entrée dans la vie professionnelle de
    tous les jeunes, sur tous les territoires.
  </p>
</div>
